import { Component } from "@angular/core";
import { FieldType } from "@kre-form/core";
import { KreFormAntService } from "../tools/service";
@Component({
  selector: "krefield-htmlcontent",
  template: `
    <ng-container *ngIf="formStatus !== 0; else other">
      <div
        class="control-design"
        [ngStyle]="{
          color: fontProperty.color,
          'font-size': fontProperty.fontSize + 'px',
          'font-style': fontProperty.fontStyle ? 'italic' : 'normal',
          'font-weight': fontProperty.fontWeight ? 'bold' : 'normal'
        }"
        [id]="field.key"
        [innerHtml]="to.description | safeHtml"
      ></div>
    </ng-container>

    <ng-template #other>
      <div
        [ngStyle]="{
          color: fontProperty.color,
          'font-size': fontProperty.fontSize + 'px',
          'font-style': fontProperty.fontStyle ? 'italic' : 'normal',
          'font-weight': fontProperty.fontWeight ? 'bold' : 'normal'
        }"
        [innerHtml]="to.description | safeHtml"
      ></div>
    </ng-template>
  `,
})
export class KreFormFieldHTML extends FieldType {}
